
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { getSearchQuery, setSearchQuery } from "@/utils/constants";
import { useToast } from "@/hooks/use-toast";

const ADMIN_PASSWORD = "admin123"; // In a real app, this would be stored securely

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [searchQuery, setLocalSearchQuery] = useState(getSearchQuery());
  const [error, setError] = useState("");
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setError("");
      setPassword("");
    } else {
      setError("Invalid password");
    }
  };

  const handleUpdateQuery = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setSearchQuery(searchQuery);
      toast({
        title: "Success",
        description: "Search query updated successfully.",
      });
      // Force a page reload to ensure the new query is used
      window.location.href = '/';
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to update search query.",
      });
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <Card className="w-full max-w-md p-6 space-y-6">
          <div className="space-y-2 text-center">
            <h1 className="text-2xl font-bold">Admin Access</h1>
            <p className="text-muted-foreground">Enter password to continue</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error && <p className="text-sm text-destructive">{error}</p>}
            </div>
            <Button type="submit" className="w-full">
              Login
            </Button>
          </form>
          <div className="text-center">
            <Link to="/" className="text-sm text-primary hover:text-primary/80">
              Back to Home
            </Link>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <main className="container px-4 py-16 mx-auto max-w-2xl">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-primary hover:text-primary/80">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
        </div>

        <Card className="p-6 space-y-6">
          <div className="space-y-2">
            <h1 className="text-2xl font-bold">Admin Settings</h1>
            <p className="text-muted-foreground">
              Update the news search query here.
            </p>
          </div>

          <form onSubmit={handleUpdateQuery} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="searchQuery" className="text-sm font-medium">
                News Search Query
              </label>
              <Input
                id="searchQuery"
                value={searchQuery}
                onChange={(e) => setLocalSearchQuery(e.target.value)}
                placeholder="Enter search query"
              />
              <p className="text-sm text-muted-foreground">
                Use quotes for exact matches and boolean operators (AND, OR) for complex queries
              </p>
            </div>
            <div className="flex justify-end">
              <Button type="submit">
                Update Query
              </Button>
            </div>
          </form>
        </Card>
      </main>
    </div>
  );
};

export default Admin;
